<div class="not-found full-background-text">
  <h1>
    {{ 'COMPANY.SO_SORRY' | translate }}
    <br />
    {{ 'COMPANY.COULDNT_FIND_YOU_LOOKING' | translate }}
  </h1>
  <div class="mt-3">
    <button type="button" class="primary-button" routerLink="/dashboard">
      {{ 'COMPANY.GO_BACK_DASHBOARD' | translate }}
    </button>
  </div>
</div>
